// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../../bundles/Form/Form.res.js";

let initialCart_products = [];

let initialCart_discounts = [];

let initialCart = {
  products: initialCart_products,
  discounts: initialCart_discounts,
  decimalPrecision: 5,
  currency: "Eur",
  taxesFree: false,
  standardTaxRate: 20
};

function get(values, field) {
  switch (field) {
    case "Condition" :
      return values.condition;
    case "NoteForSupplier" :
      return values.noteForSupplier;
    case "SupplierId" :
      return values.supplierId;
    case "IssueDate" :
      return values.issueDate;
    case "EstimatedReceptionDate" :
      return values.estimatedReceptionDate;
    case "Note" :
      return values.note;
    case "Cart" :
      return values.cart;
    case "ShopId" :
      return values.shopId;
    case "DeviceId" :
      return values.deviceId;
    case "SupplierName" :
      return values.supplierName;
    case "SupplierAddress" :
      return values.supplierAddress;
    case "SupplierPostalCode" :
      return values.supplierPostalCode;
    case "SupplierCity" :
      return values.supplierCity;
    case "SupplierCountry" :
      return values.supplierCountry;
  }
}

function set(values, field, value) {
  switch (field) {
    case "Condition" :
      return {
        condition: value,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "NoteForSupplier" :
      return {
        condition: values.condition,
        noteForSupplier: value,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "SupplierId" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: value,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "IssueDate" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: value,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "EstimatedReceptionDate" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: value,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "Note" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: value,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "Cart" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: value,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "ShopId" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: value,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "DeviceId" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: value,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "SupplierName" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: value,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "SupplierAddress" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: value,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "SupplierPostalCode" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: value,
        supplierCity: values.supplierCity,
        supplierCountry: values.supplierCountry
      };
    case "SupplierCity" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: value,
        supplierCountry: values.supplierCountry
      };
    case "SupplierCountry" :
      return {
        condition: values.condition,
        noteForSupplier: values.noteForSupplier,
        supplierId: values.supplierId,
        issueDate: values.issueDate,
        estimatedReceptionDate: values.estimatedReceptionDate,
        note: values.note,
        cart: values.cart,
        shopId: values.shopId,
        deviceId: values.deviceId,
        supplierName: values.supplierName,
        supplierAddress: values.supplierAddress,
        supplierPostalCode: values.supplierPostalCode,
        supplierCity: values.supplierCity,
        supplierCountry: value
      };
  }
}

let Lenses_ = {
  get: get,
  set: set
};

let Lenses = {
  get: get,
  set: set
};

let include = Form.Make(Lenses);

let Core = include.Core;

let Schema = include.Schema;

let FormLegacyProvider = include.FormLegacyProvider;

let FormProvider = include.FormProvider;

let InputText = include.InputText;

let InputSuggestionComboBox = include.InputSuggestionComboBox;

let InputSelect = include.InputSelect;

let InputToggleButtonGroup = include.InputToggleButtonGroup;

let InputCountrySelect = include.InputCountrySelect;

let InputTextArea = include.InputTextArea;

let InputPassword = include.InputPassword;

let InputNumber = include.InputNumber;

let InputOptionalNumber = include.InputOptionalNumber;

let InputRadioGroup = include.InputRadioGroup;

let InputRadioCardGroup = include.InputRadioCardGroup;

let InputPhone = include.InputPhone;

let InputCheckbox = include.InputCheckbox;

let InputToggleSwitch = include.InputToggleSwitch;

let InputDate = include.InputDate;

let InputOptionalDate = include.InputOptionalDate;

let InputOptionalDateFastNav = include.InputOptionalDateFastNav;

let InputDateRange = include.InputDateRange;

let CancelButton = include.CancelButton;

let SubmitButton = include.SubmitButton;

let ControlEnterKey = include.ControlEnterKey;

let AutoSave = include.AutoSave;

let useFormPropState = include.useFormPropState;

let useField = include.useField;

let useFormState = include.useFormState;

let useFormDispatch = include.useFormDispatch;

let validate = include.validate;

let isValidField = include.isValidField;

export {
  initialCart,
  Lenses_,
  Lenses,
  Core,
  Schema,
  FormLegacyProvider,
  FormProvider,
  InputText,
  InputSuggestionComboBox,
  InputSelect,
  InputToggleButtonGroup,
  InputCountrySelect,
  InputTextArea,
  InputPassword,
  InputNumber,
  InputOptionalNumber,
  InputRadioGroup,
  InputRadioCardGroup,
  InputPhone,
  InputCheckbox,
  InputToggleSwitch,
  InputDate,
  InputOptionalDate,
  InputOptionalDateFastNav,
  InputDateRange,
  CancelButton,
  SubmitButton,
  ControlEnterKey,
  AutoSave,
  useFormPropState,
  useField,
  useFormState,
  useFormDispatch,
  validate,
  isValidField,
}
/* include Not a pure module */
